import { Controller } from "@hotwired/stimulus"

const LLM_URLS = {
  claude: "https://claude.ai/new?q=",
  chatgpt: "https://chatgpt.com/?q=",
  perplexity: "https://www.perplexity.ai/search?q=",
  gemini: "https://gemini.google.com/app?q="
}

export default class extends Controller {
  static targets = ["copyBtn", "copyLabel"]
  static values = {
    verb: String,
    question: String
  }

  openLlm(event) {
    event.preventDefault()
    const provider = event.params.provider
    const baseUrl = LLM_URLS[provider]

    if (!baseUrl) return

    const url = `${baseUrl}${encodeURIComponent(this.questionValue)}`

    this.track("landing_ai_click", { provider, verb: this.verbValue })

    window.open(url, "_blank", "noopener")
  }

  copyQuestion(event) {
    event.preventDefault()

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.questionValue)
        .then(() => this.showCopied())
        .catch(() => this.fallbackCopy())
    } else {
      this.fallbackCopy()
    }

    this.track("landing_ai_copy", { verb: this.verbValue })
  }

  // --- Private ---

  fallbackCopy() {
    const textarea = document.createElement("textarea")
    textarea.value = this.questionValue
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
    this.showCopied()
  }

  showCopied() {
    if (!this.hasCopyLabelTarget) return

    const original = this.copyLabelTarget.textContent
    this.copyLabelTarget.textContent = "Copié !"
    this.copyBtnTarget.classList.add("copied")

    setTimeout(() => {
      this.copyLabelTarget.textContent = original
      this.copyBtnTarget.classList.remove("copied")
    }, 2000)
  }

  track(eventName, properties = {}) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (!token) return

    fetch("/api/landing_reservations/track", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({
        event: eventName,
        properties: { ...properties, url: window.location.href, referrer: document.referrer }
      }),
      keepalive: true
    }).catch(() => {})
  }
}
